'use es6'; // These are used ONLY to attach to nodes for acceptance test purposes

export const CREATE_A_BUNDLE = 'create-a-bundle';
export const CRM_SUITE_STARTER = 'crm-suite-STARTER';
export const CRM_SUITE_PROFESSIONAL = 'crm-suite-PROFESSIONAL';
export const CRM_SUITE_ENTERPRISE = 'crm-suite-ENTERPRISE';